import React from 'react';
import { cn } from '../../poker-ui/utils/cn';

const TABLE_PILL =
  'inline-flex max-w-[8.5rem] items-center gap-1 rounded-full border px-2 py-0.5 text-[10px] font-bold leading-tight shadow-sm sm:max-w-[10rem] sm:px-2.5 sm:py-1 sm:text-xs';
const COMPACT_PILL =
  'inline-flex max-w-[5.5rem] items-center gap-0.5 rounded-full border px-1 py-px text-[7px] font-bold leading-tight shadow-sm sm:text-[8px]';

/**
 * «Капли» — последовательность ходов базара.
 *
 * @param {{
 *   auctionLog: Array<{ id?: string, seat: number, kind?: string, label?: string, at?: number }>,
 *   seatDisplayName: (seat: number, heroName: string) => string,
 *   heroName: string,
 *   onOpenFullLog?: () => void,
 *   variant?: 'compact' | 'table',
 * }} props
 */
export function BelotAuctionMovesRiver({
  auctionLog,
  seatDisplayName,
  heroName,
  onOpenFullLog,
  variant = 'compact',
}) {
  const rows = Array.isArray(auctionLog) ? auctionLog.slice(-18) : [];
  const isTable = variant === 'table';
  if (!rows.length) return null;

  return (
    <div className={cn('flex w-full flex-col items-center', isTable ? 'gap-1.5' : 'gap-1')}>
      <div className={cn('flex max-w-full flex-wrap justify-center', isTable ? 'gap-1.5' : 'gap-1')}>
        {rows.map((row) => {
          const k = String(row.kind || '').toLowerCase();
          const nm = seatDisplayName(Number(row.seat), heroName);
          const short = nm.length > 2 ? `${nm.slice(0, 1)}…` : nm;
          const text =
            k === 'bid' ? String(row.label || '').replace(/^Бид\s+/i, '').trim() || '—' : row.label || '—';
          const tone =
            k === 'pass'
              ? 'border-rose-400/40 bg-rose-950/50 text-rose-50'
              : k === 'bid'
                ? 'border-sky-400/45 bg-gradient-to-b from-sky-600/90 to-blue-800/90 text-white shadow-[0_0_10px_rgba(56,189,248,0.22)]'
                : k === 'recontra'
                  ? 'border-amber-200/50 bg-amber-600/35 text-amber-50'
                  : 'border-amber-400/45 bg-amber-900/45 text-amber-50';
          return (
            <span
              key={row.id || `${row.seat}-${row.at}-${k}-${text}`}
              className={cn(isTable ? TABLE_PILL : COMPACT_PILL, tone)}
              title={`${nm}: ${text}`}
            >
              <span className="shrink-0 opacity-85">{short}</span>
              <span className="min-w-0 truncate font-mono">{text}</span>
            </span>
          );
        })}
      </div>
      {typeof onOpenFullLog === 'function' ? (
        <button
          type="button"
          onClick={onOpenFullLog}
          className={cn(
            'rounded border border-white/15 bg-black/35 font-semibold uppercase tracking-wide text-muted-foreground hover:bg-black/50 hover:text-foreground',
            isTable
              ? 'px-2 py-0.5 text-[9px] sm:px-2.5 sm:py-1 sm:text-[10px]'
              : 'px-1.5 py-px text-[7px] sm:text-[8px]',
          )}
        >
          Все ходы
        </button>
      ) : null}
    </div>
  );
}
